module.exports = __webpack_public_path__ + "img/prodmat.2fc77261.svg";